import { SalesComparisonRows } from '../types.ts';

export const splitSalesComparisonRows = (rows: SalesComparisonRows, rowsPerPage: number) => {
  if (rows.length <= rowsPerPage) {
    return { firstPageRows: rows, continuationRows: [] as SalesComparisonRows };
  }

  return {
    firstPageRows: rows.slice(0, rowsPerPage),
    continuationRows: rows.slice(rowsPerPage),
  };
};
